import React, { useContext, useMemo } from 'react';
import getConfig from 'next/config';

export const Context = React.createContext();

export const useApplicationSettingsContext = () => useContext(Context);

export const Provider = ({ children }) => {
  const { publicRuntimeConfig } = useMemo(() => getConfig(), []);
  return (
    <Context.Provider value={publicRuntimeConfig}>{children}</Context.Provider>
  );
};
